export function carrierAssetKey(companyInsuranceCarrier) {
  const {carrier, tpa} = companyInsuranceCarrier;

  return tpa || carrier;
}
